import './App.css';
import { v4 as uuidv4 } from 'uuid';


function copyFunc(e) {
  // e.preventDefault();
  const copyText = document.querySelector('h2').textContent;
  const input = document.querySelector('.hidden');
  const button = e.target;

  input.select();
  input.setSelectionRange(0, 99999); // For mobile devices
  document.execCommand('copy')
  // navigator.clipboard.writeText(copyText);
  button.textContent = "Text copied!"
}

function App() {
  const id = uuidv4();

  return (
    <div className="App">
      <header className="App-header">
        <h1>Your brand new ID:</h1>
        <input className="hidden" type="text" readOnly value={id} />
        <h2>{id}</h2>
        <button onClick={(e) => copyFunc(e)}>Copy to clipboard</button>
      </header>
    </div>
  );
}

export default App;
